import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Box } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

interface FilePreviewProps {
  file: { file: string; url: string } | null;
  displayPreview: boolean;
}

const FilePreview: React.FC<FilePreviewProps> = ({ displayPreview, file }) => {
  if (!displayPreview) return null;

  const fileExtension = file?.file.split('.').pop()?.toLowerCase();

  const getPreviewUrl = (url: string | undefined, fileType: string | undefined) => {
    if (!url) {
      return '';
    }
    if (!fileType) return url;

    switch (fileType) {
      case 'pdf':
        return `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
      case 'doc':
      case 'docx':
        return `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
      case 'xls':
      case 'xlsx':
        return `https://docs.google.com/spreadsheets/d/e/2PACX-1vTfu2j5wucF5M2YrHDKX1hH8BlP9A0uLOA7xTydkwIjw7Yjv39t9WqEdXgnpL3P-4A0DzByH1W7Kp/format=${fileType}&url=${encodeURIComponent(url)}&embedded=true`;
      case 'csv':
        return `https://docs.google.com/spreadsheets/d/e/2PACX-1vTfu2j5wucF5M2YrHDKX1hH8BlP9A0uLOA7xTydkwIjw7Yjv39t9WqEdXgnpL3P-4A0DzByH1W7Kp/format=${fileType}&url=${encodeURIComponent(url)}&embedded=true`;
      case 'jpg':
      case 'jpeg':
      case 'png':
        return url;
      default:
        return url;
    }
  };

  const previewUrl = getPreviewUrl(file?.url, fileExtension);

  const handleDownload = () => {
    if (file?.url) {
      window.open(file.url, '_blank');
    }
  };

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography sx={{ bgcolor: '#e0e0e0', padding: '10px'}}>Aperçu</Typography>
      {file?.url ? (
        <>
          <Box sx={{ textAlign: 'right', p: 1 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleDownload}
              startIcon={<CloudUploadIcon />}
            >
              Télécharger le fichier
            </Button>
          </Box>
          <CardContent sx={{ flexGrow: 1 }}>
            {fileExtension === 'pdf' ? (
              <iframe
                src={previewUrl}
                title="File Preview"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
              />
            ) : fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png' ? (
              <CardMedia
                component="img"
                image={previewUrl}
                alt="File Preview"
                sx={{ maxHeight: '80%', objectFit: 'contain' }}
              />
            ) : fileExtension === 'doc' || fileExtension === 'docx' ? (
              <iframe
                src={previewUrl}
                title="File Preview"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
              />
            ) : fileExtension === 'xls' || fileExtension === 'xlsx' || fileExtension === 'csv' ? (
              <iframe
                src={previewUrl}
                title="File Preview"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
              />
            ) : (
              <Typography sx={{ ml: '10px'}}>Aperçu non disponible pour ce type de fichier</Typography>
            )}
          </CardContent>
        </>
      ) : (
        <Typography sx={{ ml: '10px', mt: '10px'}}>Sélectionnez un fichier pour afficher l'aperçu</Typography>
      )}
    </Card>
  );
};

export default FilePreview;
